'use client'

import { createClient } from '@/core/supabase/client'
import mime from 'mime'
import { Upload } from 'tus-js-client'
import { v4 as uuidv4 } from 'uuid'

export const uploadWithTus = async (
  file: File,
  directory: string,
  onProgress: (progress: number) => void,
  signal?: AbortSignal,
) => {
  const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL
  if (!supabaseUrl) {
    throw new Error(
      'Variáveis de ambiente do Supabase não configuradas. ' +
        'Configure NEXT_PUBLIC_SUPABASE_URL (e NEXT_PUBLIC_SUPABASE_ANON_KEY) e faça um novo deploy.',
    )
  }

  const client = createClient()
  const {
    data: { session },
  } = await client.auth.getSession()

  const key = `${directory}/${uuidv4()}.${mime.getExtension(file.type)}`
  const endpoint = `${supabaseUrl}/storage/v1/upload/resumable`

  return new Promise<string>((resolve, reject) => {
    const upload = new Upload(file, {
      endpoint,
      retryDelays: [0, 3000, 5000, 10000, 20000],
      headers: {
        authorization: `Bearer ${session?.access_token}`,
        'x-upsert': 'true',
      },
      uploadDataDuringCreation: true,
      removeFingerprintOnSuccess: true,
      metadata: {
        bucketName: 'app',
        objectName: key,
        contentType: file.type,
        cacheControl: '3600',
      },
      chunkSize: 6 * 1024 * 1024, // NOTE: it must be set to 6MB (for now) do not change it
      onError: (error) => {
        console.error('Erro no upload:', error)
        reject(error)
      },
      onProgress: (bytesUploaded, bytesTotal) => {
        const percentage = Math.round((bytesUploaded / bytesTotal) * 100)
        onProgress(percentage)
      },
      onSuccess: () => {
        resolve(`${supabaseUrl}/storage/v1/object/app/${key}`)
      },
    })

    if (signal) {
      signal.addEventListener('abort', () => {
        console.log('Cancelando upload')
        upload.abort()
        reject(new Error('Upload cancelado'))
      })
    }

    upload.start()
  })
}
